import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@nautilusbio/nb-design-system/styles/all.css';

import App from './App.tsx';
import './styles/index.css';
import styles from './styles/index.module.css';
// Removed temporary navigation instrumentation import. Keep console silence
// module out of the normal bootstrap to avoid hiding important logs.

const rootElement = document.querySelector('#appRoot')!;

rootElement.classList.add(styles.mainAppRoot);

// If we landed via server-side login redirect, set a short navigation lock
// so early route guards/handlers don't immediately redirect back to /login
// while the session cookie is still propagating.
if (typeof window !== 'undefined' && window.location.search.includes('login=success')) {
  try {
    // 10s should be enough for cookie propagation in dev environments
    sessionStorage.setItem('__nav_lock_until', String(Date.now() + 10000));
  } catch {
    // ignore
  }
}

if (!rootElement.innerHTML) {
  // Normal bootstrap — no dev instrumentation.

  const root = createRoot(rootElement);

  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
